export default {
  "authFailed": "No se pudo completar la configuración del portal",
  "authFailureHelp": "No se pudo restablecer la sesión segura del club. Reinténtalo o inicia sesión de nuevo.",
  "signInAgain": "Iniciar sesión de nuevo",
  "retry": "Reintentar",
  "restoringAuth": "Restableciendo la autenticación...",
  "resolvingOrg": "Resolviendo la organización...",
  "loadingIdentity": "Cargando la identidad...",
  "checkingClub": "Comprobando los datos del club...",
  "clubNotFound": "Club no encontrado",
  "invalidLink": "El enlace que has seguido no es válido.",
  "verifyFailed": "No se pudo verificar la sesión",
  "verifyHelp": "Privana no pudo confirmar tu sesión de Auth0. Inicia sesión de nuevo para continuar.",
  "signIn": "Iniciar sesión",
  "close": "Cerrar",
  "broadcastResult": "Enviado por SMS: {sent}. Fallidos: {failed}. Omitidos: {skipped}.",
  "activeScope": "Jugadores activos incluidos: {count}.",
  "inherit": "Idioma del club",
  "saveFailed": "No se pudo guardar el idioma. Inténtalo de nuevo."
};
